import { circleStyles, containerStyles } from "./Switch.styles";

export interface SwitchIndicatorProps {
  isSelected: boolean;
  isHovered: boolean;
  isFocused: boolean;
}

export function SwitchIndicator({ isSelected, isHovered, isFocused }: SwitchIndicatorProps) {
  return (
    <div
      className={containerStyles({
        isSelected,
        isHovered,
        isFocused,
      })}
    >
      <div className={circleStyles({ isSelected })} />
    </div>
  );
}
